import NavCard from '@/components/NavCard/NavCard'
import {
  links_getUrl,
  links_getQuery,
  getLinksAll,
  getLinksUrlLinks,
} from '@/composables/linksMixMethods'
import { SNK } from '@/helpers/helpers'
import { namespaces } from '@/helpers/constants'

const links_mix = {
  methods: {
    links_getLink({
      asRouterLink = false,
      namespace,
      pathName = 'PracticeTrainer',
      customQuery = {},
      hasBoardFilter = false,
      hasTmpBoard = false,
    } = {}) {
      const args = {
        asRouterLink,
        namespace,
        pathName,
        customQuery,
        hasBoardFilter,
        hasTmpBoard,
      }
      return asRouterLink
        ? {
            name: pathName,
            query: links_getQuery(args),
          }
        : links_getUrl(args)
    },
    links_getItem({ options, pathName, id }) {
      return options.find(i => (pathName ? i.pathName === pathName : i.id === id))
    },
    links_openNewTab({ query, pathName = 'StudySolutions' }) {
      const paths = {
        StudySolutions: '/solutions/',
      }
      const path = paths[pathName]

      const params = new URLSearchParams(query)

      const url = `${window.location.origin}${path}?${params}`
      window.open(url, '_blank')
    },
    links_clickPreventLocalNav(e) {
      if (e.ctrlKey || e.metaKey) return
      e.preventDefault()
    },
  },
  computed: {
    links_all() {
      return getLinksAll()
    },
    links_menu() {
      const { Dashboard, StudyStudy, Practice, AnalyzeOriginal, Play } = this.links_all
      const res = [
        Dashboard,
        {
          ...StudyStudy,
          query: {
            ...this.$store.getters.query_cussol,
            soltab: this.$store.getters.sw_tabs_study,
          },
        },
        Practice,
        { ...AnalyzeOriginal, pathName: 'AnalyzeHandsV3' },
        Play,
      ]
      return res
    },
    links_study_solutions() {
      const { StudySolutions, StudyReports, Coaching, StudyPlansDashboard } = this.links_all
      const sw_tabs_study = this.$store.getters.sw_tabs_study

      const solutionsTab = sw_tabs_study === 'reports' ? 'strategy' : sw_tabs_study || 'strategy'

      const res = [
        {
          ...StudySolutions,
          query: {
            // prettier-ignore
            ...this.$store.getters[SNK('query_gmfSelector',  namespaces.STUDY)],
            ...this.$store.getters[SNK('query_cussol', namespaces.STUDY)],
            soltab: solutionsTab,
            gmfs_solution_tab: 'ai_sols',
          },
          isActiveCheck: () => this.$route.name === 'StudySolutions' && sw_tabs_study !== 'reports',
          fn: () => {
            this.$store.dispatch('switchers_set_item', {
              key: 'sw_tabs_study',
              item: { payload: solutionsTab },
            })
            this.$store.dispatch('poker_sync_study_tabs', { soltab: 'strategy' })
          },
        },
        {
          ...StudyReports,
          query: {
            ...StudyReports.query,
            // prettier-ignore
            ...this.$store.getters[SNK('query_gmfSelector',  namespaces.REPORTS)],
            ...this.$store.getters[SNK('query_cussol', namespaces.REPORTS)],
            soltab: 'reports',
            gmfs_solution_tab: 'ai_reports',
          },
          isActiveCheck: () => this.$route.name === 'StudySolutions' && sw_tabs_study === 'reports',
          fn: () => {
            this.$store.dispatch('switchers_set_item', {
              key: 'sw_tabs_study',
              item: { payload: 'reports' },
            })
            this.$store.dispatch('poker_sync_study_tabs', { soltab: 'reports' })
          },
        },
        Coaching,
        StudyPlansDashboard,
      ].filter(i => (i.g1_hide ? !this.$i18n.g1 : true))
      return res
    },
    links_study() {
      const res = this.links_study_solutions.map(i => ({
        ...i,
        active: i.isActiveCheck ? i.isActiveCheck() : this.$route.name === i.pathName,
      }))
      return res
    },
    links_analyze_v4() {
      const { AnalyzeFilesV4, AnalyzeHandsV3 } = this.links_all
      return [AnalyzeFilesV4, AnalyzeHandsV3]
    },

    links_practice_all() {
      const {
        Practice,
        PracticePlay,
        PracticeTrainer,
        PracticeRangeBuilder,
        PracticeDrills,
        PracticeHands,
        PracticeSessions,
        PracticeStats,
        NotExistent,
      } = this.links_all
      const trainerLive = !this.$store.getters.hands_configure
      let res = [
        Practice,
        PracticePlay,
        {
          ...PracticeTrainer,
          tag_live: trainerLive,
        },
        PracticeRangeBuilder,
        PracticeDrills,
        PracticeHands,
        PracticeSessions,
        PracticeStats,
        {
          ...NotExistent,
          title: this.$t('links.practice_range_quiz'),
          sub: this.$t('common.coming_soon'),
          icon: 'mdi-custom-table-help mdi-custom',
          style: `
          --clr-tag-back: var(--clr-black-3);
          --clr-tag: var(--clr-black-3);
          --clr-title: var(--clr-black-3);
          --clr-sub: var(--clr-black-3)
          `,
          clr: 'var(--clr-black-3)',
          disabled: true,
          id: 'quiz',
        },
      ]
      res = res.map(i => ({
        ...i,
        clr: i.clr || 'var(--clr-blue)',
        clr_main: 'var(--clr-blue)',
      }))
      return res
    },
    links_settings() {
      const {
        UserAccount,
        UserSubscription,
        UserGameSettings,
        UserAppearance,
        UserHotkeys,
        UserLanguage,
        UserCredits,
      } = this.links_all
      const res = [
        UserAccount,
        UserSubscription,
        UserCredits,
        UserGameSettings,
        UserAppearance,
        UserHotkeys,
        UserLanguage,
      ].filter(i => (i.g1_hide ? !this.$i18n.g1 : true))
      return res
    },
    links_practice_footer() {
      const res = this.links_practice_all.filter(
        i =>
          i.pathName === 'PracticePlay' ||
          i.pathName === 'PracticeStats' ||
          i.pathName === 'PracticeRangeBuilder' ||
          i.pathName === 'PracticeSessions' ||
          i.pathName === 'PracticeDrills' ||
          i.pathName === 'PracticeHands',
      )
      return res
    },
    links_practice_footer_drawer() {
      const res = this.links_practice_all.filter(
        i =>
          i.pathName === 'PracticePlay' ||
          i.pathName === 'PracticeTrainer' ||
          i.pathName === 'PracticeRangeBuilder' ||
          i.pathName === 'PracticeSessions' ||
          i.pathName === 'PracticeDrills' ||
          i.pathName === 'PracticeStats' ||
          i.pathName === 'PracticeHands',
      )
      return res
    },
    links_practice() {
      const res = this.links_practice_all.filter(i => i.id !== 'Practice')
      return res
    },
    linksAllDebug() {
      return Object.values(this.links_all).map(i => ({
        ...i,
        title: `${i.title}--${i.pathName}`,
      }))
    },
    links_url_links() {
      return getLinksUrlLinks()
    },
    links_url_links_byPageGuide() {
      const options = {
        AnalyzeFiles: {
          ...this.links_url_links.analyze_guide,
          text: this.$t('guides.analyze_guide'),
        },
        StudySolutions: {
          ...this.links_url_links.solution_browser,
          text: this.$t('guides.solution_browser_guide'),
        },
        PracticeTrainer: {
          ...this.links_url_links.trainer_tips_tricks,
          text: this.$t('guides.trainer_guide'),
        },
      }
      return options[this.$route.name]
    },
  },
  components: {
    NavCard,
  },
}

export default links_mix
